module.exports = __webpack_public_path__ + "img/git.039ccae6.png";